<template>
    <div style="background-color:rgb(204 204 204 / 0.25);;padding:20px">
        <div style="display:flex;justify-content: center;padding-bottom:30px">
            <h3>Company Information</h3>
        </div>
        
        <a-form-model
                ref="AddBusinessInfoform"
                :model="companyInfoform"
                :rules="rules"  
            >
                <a-row type="flex" justify="space-around">
                    <a-col :span="21">
                        <a-form-model-item label="Trade Name" ref="companyName" prop="companyName">
                            <a-input 
                                v-model="companyInfoform.companyName"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-around">
                    <a-col :span="9" >
                        <a-form-model-item label="Address" ref="address" prop="address">
                            <a-input 
                                v-model="companyInfoform.address"
                            />
                        </a-form-model-item>
                    </a-col>
                    
                    <a-col :span="9" >
                        <a-form-model-item label="Business Number" ref="businessNumber" prop="businessNumber">
                            <a-input 
                                v-model="companyInfoform.businessNumber"
                            />
                        </a-form-model-item>
                    </a-col>
                    
                </a-row>
        
                <a-row type="flex" justify="space-around">
                    <a-col :span="9" >
                        <a-form-model-item label="TIN Number" ref="tin" prop="tin">
                            <a-input 
                                v-model="companyInfoform.tin"
                            />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="9">
                        <a-form-model-item label="Number of Staffs" ref="numberOfStaffs" prop="numberOfStaffs">
                            <a-input 
                                v-model="companyInfoform.numberOfStaffs"
                            />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                
                <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                    <a-spin class="spinner" :spinning="loading" />
                </div>
          
            <a-form-model-item style="display: flex;justify-content: center;align-items: center;padding-top:50px;">
                <a-button @click="handleSubmit"  style="background: #418a49;height:45px;color:#fff;width:256px;">
                    Save & Continue
                </a-button>
            </a-form-model-item>
        </a-form-model>

        <a-modal
        class="modalStyle"
        :visible="addOnboardVisible"
        :footer="null"
        @cancel="handleCancel"
        >
        <div style="display:flex;justify-content: center;">
            <img src="../../assets/img/undraw_happy_announcement_ac_67.png" />
        </div>
        <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Yaay, Onboarding Completed</p>

        <div style="display: flex;justify-content: center;align-items: center;padding-top:40px;">
            <a-button @click="handleDashboard" style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                Enter Dashboard
            </a-button>
        </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
    export default {
        name: "CompanyInfo",
        data(){
            return{
                companyInfoform:{
                    companyName:"",
                    region:"",
                    district:"",
                    town:"",
                    isBusinessRegistered:"",
                    yearOfRegistration:"",
                    businessRegNumber:"",
                    vetCouncil:"",
                    vetCouncilYearOfReg:"",
                    vetCouncilRegState:"",
                    tin:"",
                    numberOfStaffs:""
                },
                regions:[],
                districts:[],
                towns:[],
                addOnboardVisible: false,
                loading:false,
                showIsRegistered:false,
                showIsVetCouncil:false,
                rules: {
                    companyName: [
                        { required: true, message: 'Please enter your trade name' , trigger: 'change'},
                        
                    ],
                    businessNumber: [
                        { required: true, message: 'Please enter your business number' , trigger: 'change'},
                        
                    ],
                    address: [
                        { required: true, message: 'Please enter your company address' , trigger: 'change'},
                        
                    ],       
                    tin: [
                        { required: true, message: 'Please enter your tin' , trigger: 'change'},
                    ],
                    numberOfStaffs: [
                        { required: true, message: 'Please enter your number of staffs' , trigger: 'change'},
                    ],
                 
                },
            }
        },
        computed: mapGetters(['getCompanyInfo']),
        methods:{
            ...mapActions(['setStepCount', 'setCompanyInfo','getAgentProfile','setPercentageBar']),
            handleSubmit(){
                
                this.$refs.AddBusinessInfoform.validate(valid => {
                    if (valid) {
                        this.setCompanyInfo(this.companyInfoform)
                        // this.setStepCount(2)
                        // this.setPercentageBar(50);
                        console.log("next to shop")
                        this.$router.push(`/setup-shop`).catch(()=>{});
                    }else {
                        this.loading = false
                        return false;
                    }
                })
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            handleCancel(){
                this.addOnboardVisible = false
            },
            handleDashboard(){
                this.$router.push('/overview');
            },
            OnChangeRegion(value){
                // console.log("value | ", value)
                this.getDistrictById(value).then(response => {
                    this.districts = response.data.data
                },
                error => {
                    console.log('Error | ', error)
                })
            },
            OnChangeDistrict(value){
                this.getTownById(value).then(response => {
                    this.towns = response.data.data
                },
                error => {
                    console.log('Error | ', error)
                })
            },
            onChangeBusinessRegistration(value){
                // console.log('value | ', value)
                if(value === "true"){
                    this.showIsRegistered = true
                }else{
                    this.showIsRegistered = false
                }
            },
            onChangeVetCouncil(value){
                if(value === "true"){
                    this.showIsVetCouncil = true
                }else{
                    this.showIsVetCouncil = false
                }
            }
        },
        created(){
            // console.log("getAllRegion | ", this.getAllRegion)
            if(this.getAllRegion){
                this.getAllRegion().then(response => {
                    this.regions = response.data.data
                },
                error => {
                    console.log('Error | ', error)
                })
            }
            
            if(this.getCompanyInfo){
                // console.log("getCompanyInfo | ", this.getCompanyInfo)
                // this.onChangeBusinessRegistration(this.getCompanyInfo.isBusinessRegistered);
                // this.onChangeVetCouncil(this.getCompanyInfo.vetCouncil)
                // this.OnChangeRegion(this.getCompanyInfo.region)
                // this.OnChangeDistrict(this.getCompanyInfo.district)
                this.companyInfoform = {
                    companyName:this.getCompanyInfo.companyName,
                    address: this.getCompanyInfo.address,
                    businessNumber: this.getCompanyInfo.businessNumber,
                    tin:this.getCompanyInfo.tin,
                    numberOfStaffs:this.getCompanyInfo.numberOfStaffs
                }

            }
        }
    }
</script>

<style scoped>
.img_size{
    max-width: 56px;
    max-height: 55px;
}
</style>